import ExtendedBadge from "@/components/ExtendedBadge";
import {  GripHorizontal } from "lucide-react";

interface IProps {
    amount: number
    createdAt: string
    currency: string
    paymentMethod: string
    status: string
    transactionReference: string


}


export default function PaymentTile({ ...props }: IProps) {

        const getstatus = (status: string) => {
            switch (status) {
                case "PENDING":
                    return "warning"
                case "Approved":
                    return "success"
                case "Rejected":
                    return "danger"
                default:
                    return "warning"
            }
        }
    
    return (
        <div className="flex justify-around items-center bg-white shadow-sm rounded-lg p-2 mt-4">
            <div >
                <span className="font-bold text-sm block">Mixx by Yas</span>
                <span className="font-light text-gray-400 text-sm">{props.paymentMethod}</span>
            </div>
            <div >
                <span className="font-bold text-sm block">{props.amount} <span className="text-gray-400">{props.currency}</span> </span>
                <span className="font-light text-gray-400 text-sm">{props.createdAt}</span>
            </div>
            <div className="font-light text-gray-400 text-sm">{props.transactionReference}</div>
            <div>
                <ExtendedBadge
                    label={props.status}
                    variant={getstatus(props.status)}
                />
            </div>
            <div className="rounded-lg h-8 w-8 flex items-center justify-center border border-gray-200">
                <GripHorizontal size={20} />
            </div>
        </div>
    )
}